/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';
import Cookies from 'js-cookie';

const { state } = store('gt/fse/filtres', {
    actions: {
        runFilters: (e) => {
            if (e !== undefined && e.type !== "load") {
                // Find the container of the clicked filter
                let filterContainer = e.target.closest('.gt-hebergements-filtre');

                // Check/uncheck "All" checkbox based on individual selections
                let allCheckbox = filterContainer.querySelector('input[value=""]');
                let allChecked = filterContainer.querySelectorAll('input:checked:not([value=""])');
                allCheckbox.checked = allChecked.length === 0;

                // Store selected filter values in cookies and fse state
                let cookieName = filterContainer.getAttribute('data-gt-cookie');

                if (cookieName) {
                    let cookieValue = Array.from(allChecked).map(checkbox => checkbox.value);
                    Cookies.set(cookieName, cookieValue);
                }
            }

            // Initialize the filters object and count of active filters
            let filters = {};
            let activeFilterCount = 0;

            // Loop over all active filters and collect the checked values
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let operator = activeFilterContainer.getAttribute('data-gt-filtre-operator') || 'OR'; // Default to "OR" operator

                if (filterName) {
                    let selectedValues = Array.from(activeFilterContainer.querySelectorAll('input:checked:not([value=""])'))
                        .map(input => input.value);

                    // Only add filters with selected values to the filters object
                    if (selectedValues.length > 0) {
                        filters[filterName] = {
                            values: selectedValues,
                            operator: operator
                        };
                        activeFilterCount++; // Count active filters with at least one checked value
                    }
                }
            });

            state.activeCheckboxes = document.querySelectorAll('.gt-hebergements-filtre input:checked:not([value=""])').length;

            // Hide/show each hebergement based on the selected filters
            let visibleHebergements = [];
            document.querySelectorAll('.gt-fse-hebergements .hebergement').forEach(hebergement => {
                let shouldShow = true;

                // Check each filter against the data attributes of the hebergement
                Object.keys(filters).forEach(filterName => {
                    let dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);

                    if (dataAttribute) {
                        // Convert the data-attribute value into an array if it's a string
                        let dataValues = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];
                        let filter = filters[filterName];
                        let { values, operator } = filter;

                        let matches = false;
                        switch (operator) {
                            case 'AND':
                                // Ensure all selected values are present in the dataValues
                                matches = values.every(value => dataValues.includes(value));
                                break;
                            case '<=':
                                // Match if all dataValues are less than or equal to filter values (assuming numerical comparison)
                                matches = values.every(value => parseInt(dataValues[0]) <= parseInt(value));
                                break;
                            case '>=':
                                // Match if all dataValues are greater than or equal to filter values (assuming numerical comparison)
                                matches = values.every(value => parseInt(dataValues[0]) >= parseInt(value));
                                break;
                            case 'OR':
                            default:
                                // Match if any filter value is present in dataValues (default behavior)
                                matches = values.some(value => dataValues.includes(value));
                                break;
                        }

                        if (!matches) {
                            shouldShow = false;
                        }
                    }
                });

                // Toggle visibility based on the filter match
                if (shouldShow) {
                    hebergement.style.display = '';
                    visibleHebergements.push(hebergement); // Track visible hebergements
                } else {
                    hebergement.style.display = 'none';
                }
            });

            // Handle checkbox disabling logic for filters
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                let filterOperator = activeFilterContainer.getAttribute('data-gt-filtre-operator');
                let selectedCheckboxes = activeFilterContainer.querySelectorAll('input:checked:not([value=""])');

                // Check if this is the only filter with selected checkboxes
                let isActiveFilter = selectedCheckboxes.length > 0 && activeFilterCount === 1;

                if (isActiveFilter && filterOperator != 'AND') {
                    return;
                }

                // Loop over all checkboxes within this filter
                activeFilterContainer.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    let checkboxValue = checkbox.value;

                    // Skip the "All" checkbox
                    if (checkboxValue === '') {
                        return;
                    }

                    let shouldEnable = false;

                    // Check visible hebergements to determine if the checkbox should be enabled
                    visibleHebergements.forEach(hebergement => {
                        let dataAttribute = hebergement.getAttribute(`data-gt-${filterName}`);

                        if (dataAttribute) {
                            // Convert dataAttribute to an array if it contains commas
                            let dataValues = dataAttribute.includes(',') ? dataAttribute.split(',') : [dataAttribute];
                            let checkboxValues = checkboxValue.split(',');

                            // Determine if `some` or `every` should be used for comparison
                            let matches = !filterOperator || filterOperator != 'AND'
                                ? checkboxValues.some(value => dataValues.includes(value)) // Use `some` if the checkbox value is an array
                                : checkboxValues.every(value => dataValues.includes(value)); // Use `every` if it's a single value

                            if (matches) {
                                shouldEnable = true; // Enable the checkbox if the condition is met
                            }
                        }
                    });

                    // Enable or disable the checkbox based on the result
                    checkbox.disabled = !shouldEnable;
                });
            });

            // Update active filter count
            document.querySelectorAll('.gt-hebergements-filtre').forEach(activeFilterContainer => {
                let selectedCheckboxes = activeFilterContainer.querySelectorAll('input:checked:not([value=""])');
                let filterName = activeFilterContainer.getAttribute('data-gt-filtre-name');
                state.count[filterName] = selectedCheckboxes.length;
            });
        },
        clearFilter: (e) => {
            const fse = store("gt/fse");
            let checkboxes = e.target.closest('.gt-hebergements-filtre').querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            e.target.checked = true;

            let cookieName = e.target.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
            if (cookieName) {
                Cookies.set(cookieName, []);
                fse.state[cookieName] = [];
            }

            store('gt/fse/filtres').actions.runFilters(e);

            // fse.actions.submitForm();
        },
        clearAllFilters: (e) => {
            const fse = store("gt/fse");
            let checkboxes = document.querySelectorAll('.gt-hebergements-filtre input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.checked = checkbox.value != "" ? false : true;

                let cookieName = checkbox.closest('.gt-hebergements-filtre').getAttribute('data-gt-cookie');
                if (cookieName) {
                    Cookies.set(cookieName, []);
                    fse.state[cookieName] = [];
                }

            });

            store('gt/fse/filtres').actions.runFilters();

        },
        toggleSidebar: (e) => {
            const context = getContext();
            context.isSidebarOpen = !context.isSidebarOpen;

            document.body.classList.toggle('gt-ws-sidebar-toggled');

        },
        toggleFilter: (e) => {
            const context = getContext();
            if(!context.isAccordeon) return;

            let filter = e.target.closest('.gt-hebergements-filtre');
            filter.classList.toggle('closed');

            if(filter.classList.contains('closed')){
                filter.setAttribute('aria-expanded', 'false');
            }
            else{
                filter.setAttribute('aria-expanded', 'true');
            }

            let filters = e.target.closest('.gt-hebergements-filtres');
            if(filters.classList.contains('gt-hebergements-filtres--grid')){
                filters.querySelectorAll('.gt-hebergements-filtre').forEach(filter => {
                    if(filter !== e.target.closest('.gt-hebergements-filtre')){
                        filter.classList.add('closed');
                        filter.setAttribute('aria-expanded', 'false');
                    }
                });
            }

        },
        handleKeydown: (e) => {
            if (e.key === 'Escape') {
                store('gt/fse/filtres').actions.toggleSidebar(e);
            }

            const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const sidebar = document.querySelector('.gt-hebergements-filtres__sidebar');
            const firstFocusableElement = sidebar.querySelectorAll(focusableElements)[0];
            const focusableContent = sidebar.querySelectorAll(focusableElements);
            const lastFocusableElement = focusableContent[focusableContent.length - 1];

            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        },
        outsideClick: (e) => {
			const el = getElement();
			const filtres = el.ref.closest('.gt-hebergements-filtres');

			if (!filtres.contains(e.target)) {

                if(filtres.classList.contains('gt-hebergements-filtres--grid')){
                    filtres.querySelectorAll('.gt-hebergements-filtre').forEach(filter => {
                        filter.classList.add('closed');
                        filter.setAttribute('aria-expanded', 'false');
                    });
                }
            }

		}
    }
});

// Sticky btn

window.addEventListener('load', () => {
    const hasSidebar = document.querySelector('.gt-hebergements-filtres--sidebar');
    if(hasSidebar){
        const actions = document.querySelector('.gt-hebergements-actions');
        actions.style.height = `${actions.offsetHeight}px`;
    }
});

window.addEventListener('load resize', () => {
    const hasSidebar = document.querySelector('.gt-hebergements-filtres--sidebar');
    if(hasSidebar){
        const actions = document.querySelector('.gt-hebergements-actions');
        actions.style.height = `${actions.offsetHeight}px`;
    }
});

window.addEventListener('scroll', () => {

    const hasSidebar = document.querySelector('.gt-hebergements-filtres--sidebar');
    if(hasSidebar){

        const actions = document.querySelector('.gt-hebergements-actions');
        const scrollTop = window.scrollY;
        const actionsBottom = actions.getBoundingClientRect().bottom + window.scrollY;

        if (scrollTop > actionsBottom) {
            actions.classList.add('sticked');
        } else {
            actions.classList.remove('sticked');
        }

    }
});
